var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{staticClass:"app-footer",attrs:{"fixed":false}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" - Powered by Center for Information Technology Services ")])])}
var staticRenderFns = []

export { render, staticRenderFns }